import siteConfig from "@iso/config/site.config";
import {
  getGetRequestInfo,
  getDeleteRequestInfo,
  getPutRequestInfo,
  getPostRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import { put } from "redux-saga/effects";
import deviceUrls from "src/infinode/constants/urls/deviceUrls";
import actions from "./actions";

const { getDeviceList, deviceRootUrl, devicePairingUrl, deviceConfigUrl } = deviceUrls;

const onGetDeviceListRequest = ({ token }) =>
  fetch(`${siteConfig.apiUrl}${getDeviceList}`, getGetRequestInfo(token)).then(response => response);

const onGetDeviceListSuccess = function* (resultBody) {
  if (resultBody.devices !== undefined) {
    yield put({
      type: actions.GET_DEVICES_SUCCESS,
      devices: resultBody.devices
    });
    return true;
  }
  return false;
};

const getDeviceListRequest = getRequestGeneratorFunction(
  actions.GET_DEVICES_REQUEST,
  actions.DEVICES_ERROR,
  onGetDeviceListRequest,
  onGetDeviceListSuccess
);

const onGetDeviceRequest = ({ token, id }) =>
  fetch(`${siteConfig.apiUrl}${deviceRootUrl}/${id}`, getGetRequestInfo(token)).then(response => response);

const onGetDeviceSuccess = function* (resultBody) {
  if (resultBody.device) {
    yield put({
      type: actions.GET_DEVICE_SUCCESS,
      device: resultBody.device
    });
    return true;
  }
  return false;
};

const getDeviceRequest = getRequestGeneratorFunction(
  actions.GET_DEVICE_REQUEST,
  actions.DEVICES_ERROR,
  onGetDeviceRequest,
  onGetDeviceSuccess
);

const onGetDeviceConfigRequest = ({ token, id }) =>
  // fetch(`${siteConfig.apiUrl}${deviceConfigUrl}/${id}`, getGetRequestInfo(token)).then(response => response); 
  //replaced by
  fetch(`${siteConfig.apiUrl}${deviceRootUrl}/${id}`, getGetRequestInfo(token)).then(response => response);

const onGetDeviceConfigSuccess = function* (resultBody, { id }) {
  if (resultBody.deviceConfig) {
    yield put({
      type: actions.GET_DEVICE_CONFIG_SUCCESS,
      id,
      deviceConfig: resultBody.deviceConfig
    });
    return true;
  }
  return false;
};

const getDeviceConfigRequest = getRequestGeneratorFunction(
  actions.GET_DEVICE_CONFIG_REQUEST,
  actions.DEVICES_ERROR,
  onGetDeviceConfigRequest,
  onGetDeviceConfigSuccess
);

const onDeleteDeviceRequest = ({ token, id }) =>
  fetch(`${siteConfig.apiUrl}${deviceRootUrl}/${id}`, getDeleteRequestInfo(token)).then(response => response);

const onDeleteDeviceSuccess = function* (resultBody, params) {
  yield console.log(resultBody);
  if (resultBody === true) {
    yield put({
      type: actions.DELETE_DEVICE_SUCCESS,
      id: params.id
    });
    return true;
  }
  return false;
};

const deleteDeviceRequest = getRequestGeneratorFunction(
  actions.DELETE_DEVICE_REQUEST,
  actions.DEVICES_ERROR,
  onDeleteDeviceRequest,
  onDeleteDeviceSuccess
);

const onUpdateDeviceRequest = ({ token, device }) =>
  fetch(`${siteConfig.apiUrl}${deviceRootUrl}/${device.id}`, getPutRequestInfo(device, token)).then(
    response => response
  );

const onUpdateDeviceSuccess = function* (resultBody) {
  if (resultBody.device) {
    yield put({
      type: actions.UPDATE_DEVICE_SUCCESS,
      device: resultBody.device
    });
    return true;
  }
  return false;
};

const updateDeviceRequest = getRequestGeneratorFunction(
  actions.UPDATE_DEVICE_REQUEST,
  actions.DEVICES_ERROR,
  onUpdateDeviceRequest,
  onUpdateDeviceSuccess
);

const mapConfigToRequestFormat = (id, configs) => {
  const deviceConfigProperties = Object.keys(configs).reduce((acc,key) => {
    acc[key] =  (configs[key]===null || configs[key]===undefined)? null:configs[key];
    return acc;
  },{});
  return { id, ...deviceConfigProperties };
};

const onUpdateDeviceConfigRequest = ({ token, id, configs }) =>
  fetch(
    // `${siteConfig.apiUrl}${deviceConfigUrl}/${id}`,
    // replaced by
    `${siteConfig.apiUrl}${deviceRootUrl}/${id}`,
    getPutRequestInfo(mapConfigToRequestFormat(id, configs), token)
  ).then(response => response);

const onUpdateDeviceConfigSuccess = function* (resultBody, { id }) {
  console.log('update device config success');
  if (resultBody.deviceConfig) {
    yield put({
      type: actions.UPDATE_DEVICE_CONFIG_SUCCESS,
      deviceConfig: resultBody.deviceConfig,
      id
    });
    return true;
  }
  return false;
};

const updateDeviceConfigRequest = getRequestGeneratorFunction(
  actions.UPDATE_DEVICE_CONFIG_REQUEST,
  actions.DEVICES_ERROR,
  onUpdateDeviceConfigRequest,
  onUpdateDeviceConfigSuccess
);

const onCreateDeviceRequest = ({ token, device }) =>
  fetch(`${siteConfig.apiUrl}${deviceRootUrl}`, getPostRequestInfo(device, token)).then(response => response);

const onCreateDeviceSuccess = function* (resultBody) {
  if (resultBody.device) {
    yield put({
      type: actions.CREATE_DEVICE_SUCCESS,
      device: resultBody.device
    });
    return true;
  }
  return false;
};

const createDeviceRequest = getRequestGeneratorFunction(
  actions.CREATE_DEVICE_REQUEST,
  actions.DEVICES_ERROR,
  onCreateDeviceRequest,
  onCreateDeviceSuccess
);

const onRequestPairingRequest = ({ token, pairingObj }) =>
  fetch(`${siteConfig.apiUrl}${devicePairingUrl}`, getPostRequestInfo(pairingObj, token)).then(response => response);

const onRequestPairingSuccess = function* (resultBody, params) {
  if (resultBody) {
    yield put({
      type: actions.REQUEST_PAIRING_SUCCESS,
      pairingResult: resultBody,
      serialNumber: params.pairingObj.serialNumber
    });
    return true;
  }
  return false;
};

const requestPairingRequest = getRequestGeneratorFunction(
  actions.REQUEST_PAIRING_REQUEST,
  actions.DEVICES_ERROR,
  onRequestPairingRequest,
  onRequestPairingSuccess
);

const onSubmitPairingRequest = ({ token, pairingObj }) =>
  fetch(`${siteConfig.apiUrl}${devicePairingUrl}`, getPutRequestInfo(pairingObj, token)).then(response => response);

const onSubmitPairingSuccess = function* (resultBody) {
  if (resultBody) {
    yield put({
      type: actions.SUBMIT_PAIRING_SUCCESS,
      pairingResult: resultBody
    });
    return true;
  }
  return false;
};

const submitPairingRequest = getRequestGeneratorFunction(
  actions.SUBMIT_PAIRING_REQUEST,
  actions.DEVICES_ERROR,
  onSubmitPairingRequest,
  onSubmitPairingSuccess
);

export default {
  getDeviceListRequest,
  getDeviceRequest,
  getDeviceConfigRequest,
  deleteDeviceRequest,
  updateDeviceRequest,
  updateDeviceConfigRequest,
  createDeviceRequest,
  requestPairingRequest,
  submitPairingRequest
};
